import { Fragment, useEffect, useContext, useState } from 'react'
import groupBy from '../../utils/groupBy'
import CardList from '../../components/CardList/CardList'
import ProjectCard from '../../components/ProjectCard/ProjectCard'
import Filter from '../../components/Filter/Filter'
import Footer from '../../components/Footer/Footer'

// context
import { FilterContext } from '../../context/FilterContext'
import EmptyState from '../../components/EmptyState/EmptyState'
import LoadMore from '../../components/LoadMore/LoadMore'
import Seo from '../../components/Seo/Seo'

// Fetch new data
const apiUrl = process.env.API_URL
const gqlFilteredProjects = require('../../queries/gqlProjectSearch.graphql')

const Projects = (props) => {
  const { projects, total, filters, metadata } = props
  // console.log("Props", props);
  // State for FilterContext
  const FilterContextState = useContext(FilterContext)

  const [cards, setCards] = useState(projects)
  const [totalCards, setTotalCards] = useState(total)

  useEffect(() => {
    document.querySelector('body').classList.add('is-project')

    // store filters data on FilterContextState
    if (!FilterContextState.status && !FilterContextState.types && !FilterContextState.regions) {
      FilterContextState.setStatus(filters.status)
      FilterContextState.setTypes(filters.types)
      FilterContextState.setRegions(filters.regions)
    }
    console.log("FilterContextState", FilterContextState);

    return () => {
      // @todo find a better alternative to clean up body classnames
      document.querySelector('body').classList.remove('is-project')
    }
  }, [])

  useEffect(() => {
    if (FilterContextState.selectedFilters.length || FilterContextState.limit) {
      fetchProjects()
    } else {
      setCards(projects)
    }
  }, [FilterContextState.selectedFilters, FilterContextState.limit])

  const fetchProjects = async () => {
    const selectedFilters = groupBy(FilterContextState.selectedFilters, 'category')

    let projectsTypesIds = Array.from(props.filters.types.items).map((item) => parseFloat(item.id));
    let statusIds = Array.from(props.filters.status.items).map((item) => parseFloat(item.id));
    let projectRegionsIds = Array.from(props.filters.regions.items).map((item) => parseFloat(item.id));
    let featuredProjectIds = [];

    if(selectedFilters.type) {
      projectsTypesIds = Array.from(selectedFilters.type).map((item) => parseFloat(item.id))

      // featuredProjectIds = Array.from(selectedFilters.type).map((item) => (item.featuredProject))
      
      //Dit zijn de projectTypeIds die zijn gekozen. Heel goed, nu nog uit zien te zoeken hoe je de featuredProject id's van die projectTypes kan ophalen
      
      // Dit werkt niet, geeft alleen maar undefined op
      // featuredProjectIds = Array.from(selectedFilters.type).map((item) => (item.featuredProject))
      // console.log("featuredProjectIds", featuredProjectIds);

      // Dus dacht zelf wat te verzinnen, maar indexOf functie geeft altijd -1, ook al zit het id wel in de array

      // Onderstaande output:
      // 731 [732] -1
      // 734 [732] -1
      // 743 [732] -1
      // 746 [732] -1
      // 732 [732] -1 //Waarom?! hij zit erin
      // 733 [732] -1
      // 748 [732] -1
      // 744 [732] -1
      // 747 [732] -1
      // 741 [732] -1
      // 745 [732] -1
      // 735 [732] -1
      // 729 [732] -1
      // 742 [732] -1
      // 749 [732] -1
      // 736 [732] -1
      // 730 [732] -1
      // 4983 [732] -1

      // for(let featuredProjectId of featuredProjectIds) {
      //   for(let projectsType of props.filters.types.items) {

      //   }
      // }

      console.log("Types:", projectsTypesIds);
      console.log("All types", JSON.stringify(props.filters.types.items));
      // for(let projectsType of props.filters.types.items) {
      //   console.log(projectsType.id, projectsTypesIds, projectsTypesIds.indexOf(projectsType.id));
      //   if(projectsTypesIds.indexOf(projectsType.id) >= 0) {
      //     console.log("Found", projectsType);
      //   }
      // }

      console.log("FeaturedProjectIds before", featuredProjectIds);
      for (const projectType of props.filters.types.items) {
        if (projectsTypesIds.includes(Number(projectType.id))) {
          const featuredProjects = projectType.featuredProject.map(({ id }) => id);
          featuredProjectIds.push(...featuredProjects);
        }
      }
      console.log("FeaturedProjectIds after", featuredProjectIds);
    }

    if(selectedFilters.status) {
      statusIds = Array.from(selectedFilters.status).map((item) => parseFloat(item.id))
    }

    if(selectedFilters.regions) {
      projectRegionsIds = Array.from(selectedFilters.regions).map((item) => parseFloat(item.id))
    }

    // Create new array and map the categories by id and parse it as integers
    const queryData = {
      variables: {
        // limit: FilterContextState.limit,
        limit: 200,
        type: projectsTypesIds,
        status: statusIds,
        regions: projectRegionsIds,
        orderBy: [
          { "field": "elements.id", "sort": "asc" }
        ]
      },
      query: gqlFilteredProjects
    }

    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(queryData)
    }

    const res = await fetch(apiUrl, opts)
    const json = await res.json()

    console.log("Projects response", json);

    // Replace project cards
    if (json.data.projects) {


      

      // Sort projects by custom logic
      json.data.projects.sort((a, b) => {
        const aIndex = featuredProjectIds.indexOf(a.id);
        const bIndex = featuredProjectIds.indexOf(b.id);

        // console.log("Checking aIndex <-> bIndex", featuredProjectIds, a.id, b.id, aIndex, bIndex);

        // If both projects have desired IDs or both projects don't have desired IDs, maintain their original order
        if ((aIndex !== -1 && bIndex !== -1) || (aIndex === -1 && bIndex === -1)) {
          // If both projects have desired IDs, sort them based on their order in the featuredProjectIds list
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          }

          return 0;
        }

        // Projects with desired IDs should come first
        if (aIndex !== -1) {
          return -1;
        }

        // Projects without desired IDs should come last
        return 1;
      });
      console.log("Projects sorted", json);
      setTotalCards(json.data.projects.length)
      setCards(json.data.projects.slice(0, FilterContextState.limit))
    }
  }

  return (
    <Fragment>
      <Seo {...metadata}/>

      <Filter filters={filters}/>

      {/* Add ProjectCard with overview layout */}
      {totalCards !== 0 ? (
        <CardList layout={`overview`} type={`projects`}>
          {cards.map((card, index) => {
            return <ProjectCard {...card} key={`ProjectCard-overview-${index}-${card.id}`}/>
          })}
        </CardList>
        ) : (
        <EmptyState title="No projects found" description="<p>It seems we can’t find any projects based on your filter settings.<br> Use the button below to reset the filter and head back to the overview.</p>" button="Reset filter" />
        )
      }

      {FilterContextState.limit <= totalCards &&
      <LoadMore onClick={() => {
        FilterContextState.setLimit(FilterContextState.limit + 9)
      }} label="More projects"/>
      }

      <Footer/>
    </Fragment>
  )
}

export async function getServerSideProps (context) {
  const query = require('../../queries/gqlProjects.graphql')

  const opts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql' },
    body: query
  }

  const res = await fetch(process.env.API_URL, opts)
  const json = await res.json()

  return {
    props: {
      projects: json.data.projects,
      total: json.data.total.length,
      filters: {
        types: {
          type: 'type',
          label: 'Select type',
          items: json.data.project_type
        },
        status: {
          type: 'status',
          label: 'Select status',
          items: json.data.status
        },
        regions: {
          type: 'regions',
          label: 'Select region',
          items: json.data.regions
        }
      },
      metadata: {
        ...JSON.parse(json.data.metadata.metaTitleContainer).title,
        ...JSON.parse(json.data.metadata.metaTagContainer)
      }
    }
  }
}

export default Projects
